import { render, staticRenderFns } from "./LpuBanners.vue?vue&type=template&id=7ca702d2&scoped=true&"
import script from "./LpuBanners.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuBanners.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuBanners.vue?vue&type=style&index=0&id=7ca702d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca702d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca702d2')) {
      api.createRecord('7ca702d2', component.options)
    } else {
      api.reload('7ca702d2', component.options)
    }
    module.hot.accept("./LpuBanners.vue?vue&type=template&id=7ca702d2&scoped=true&", function () {
      api.rerender('7ca702d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuBanners/LpuBanners.vue"
export default component.exports